export const fanakActionCodesToTranslatedCode = {
  avocat: "avocat",
  boursier: "boursier",
  Bureau: "Bureau",
  comptable: "comptable",
  "human rights": "human_rights",
  interprete: "interprete",
  LRO: "LRO",
  Admin: "Admin",
  AG: "AG",
  Banque: "Banque",
  CCP: "CCP",
  CT: "CT",
  "Delegations EU": "Delegations_EU",
  ECOC: "ECOC",
  "EU Inst": "EU_Inst",
  Fondation: "Fondation",
  Hotel: "Hotel",
  "IC/AMB": "IC_AMB",
  Inst: "Inst",
  MEP: "MEP",
  MIN: "MIN",
  Network: "Network",
  "Perm Rep": "Perm_Rep",
  Press: "Press",
  Restaurant: "Restaurant",
  UN: "UN",
  Univ: "Univ",
};
